import routes from '@modules/stripe/stripe-external-account/stripe-external-account-routes';
import store from '@modules/stripe/stripe-external-account/stripe-external-account-store';

export default {
  routes,
  store,
};
